<div class="row">
  <div class="row jcs" style="gap: 5px">
    <i class="pi pi pi-fw pi-lock color-primary fz-20"></i>
    <h2 class="no-mg">{{ 'AUTHORIZED.LABELS.PERMISSIONS' | translate }}</h2>
  </div>
  <div class="row-inline" style="gap: 10px">
    <div class="divider-v" style="height: 20px"></div>
    <button (click)="expandOrCollapseAll($event)" class="btn btn-primary-link resetbtn color-primary float-btn">
      @if (!expanded) {
        <span>
          {{ 'COMMON.BUTTONS.EXPAND_LOCATIONS' | translate }}
        </span>
      }
      @if (expanded) {
        <span>
          {{ 'COMMON.BUTTONS.COLLAPSE_LOCATIONS' | translate }}
        </span>
      }
    </button>
    @if (state !== 'details') {
      <div class="cell">
        <span class="p-input-icon-left p-input-filled" style="width: 200px">
          <i class="pi pi-search"></i>
          <input #search type="text" pInputText [placeholder]="'VISITORS.LABELS.SEARCH_ENTRANCES' | translate" (input)="updateTreeRef.treeReference._filter(search.value)" />
        </span>
      </div>
    }
  </div>
</div>
<div [class]="classes" style="width: 100%" [formGroup]="form">
  <div class="cell no-pd">
    <div class="form-group">
      <div [style.display]="state === 'details' ? 'none' : 'block'">
        <div class="row" style="gap: 15px; margin-top: 20px; align-items: flex-start">
          <div class="fw-60" style="overflow: auto" [style.height]="cardHeight">
            <app-myTree
              #updateTreeRef
              [data]="entrances"
              selectionMode="checkbox"
              [style]="{ overflow: 'hidden', 'background-color': 'unset', border: 'unset', padding: 'unset' }"
              (onNodeSelected)="nodeSelectionChanges($event)"
              (onNodeUnselected)="nodeSelectionChanges($event)"
              (onCheckBoxSelect)="nodeCheckBoxSelection($event, true)"
              (onCheckBoxUnselect)="nodeCheckBoxSelection($event, false)"
              [propagateSelectionDown]="false"
              [propagateSelectionUp]="true"
            ></app-myTree>
          </div>
          <div style="width: 38%" [style.height]="cardHeight">
            <app-card-wrapper contentHeight="calc(100% - 20px)" [cardStyle]="{ height: cardHeight, overflow: 'hidden', 'background-color': 'unset', 'border-bottom': 'unset' }">
              <div header>
                <h2 style="height: 15px">{{ selectedEntrance?.name }}</h2>
                <div class="divider-h mt-5 mt-5"></div>
              </div>
              <p-listbox
                content
                formControlName="areas"
                [options]="filteredAreas"
                [checkbox]="true"
                [multiple]="true"
                optionLabel="name"
                [showToggleAll]="false"
                (onChange)="areaSelectionChanges($event.value)"
                [style]="{ 'max-height': 'calc(100vh - 180px - 30px)' }"
                styleClass="p-field-checkbox sm"
                >
              </p-listbox>
            </app-card-wrapper>
          </div>
        </div>
      </div>
      <div [style.display]="state === 'create' || state === 'edit' ? 'none' : 'block'">
        <app-myTree
          #detailsTreeRef
          [data]="entrances"
          [style]="{ height: cardHeight, overflow: 'hidden', 'background-color': 'unset', border: 'unset', padding: '0 0 24px 0' }"
          [propagateSelectionDown]="false"
          chipDisplaySubObjectName="areas"
          [chipDisplayCompareObject]="stringAreas"
        ></app-myTree>
      </div>
    </div>
  </div>
</div>
